import { Link } from "react-router-dom";
import React from "react";
const Faciliteitensidebar = ({token, username, isActive, onToggle}) => {
  if (username.bedrijf && username.bedrijf.modules.includes("faciliteiten")) {
    if (
      token.role === "admin" ||
      token.role === "manager" ||
      token.role === "medewerker"
    ) {
      return (
        <div className="menu-item">
          <div className="menu-link" onClick={onToggle}>
            <span className="menu-icon">
              <i className="fa fa-warehouse"></i>
            </span>
            <span className="menu-text">Faciliteiten</span>
            <span className={`menu-arrow ${isActive ? "rotate" : ""}`}>
              <i className="fas fa-chevron-right"></i>
            </span>
          </div>
          <div className={`menu-sub ${isActive ? "show" : ""}`}>
            <div className="menu-item">
              <Link to="/faciliteiten" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-warehouse"></i>
                </span>
                <span className="menu-text">Faciliteiten</span>
              </Link>
            </div>
            <div className="menu-item">
              <Link to="/horeca" className="menu-link">
                <span className="menu-icon">
                  <i className="fa fa-utensils"></i>
                </span>
                <span className="menu-text">Horeca</span>
              </Link>
            </div>
          </div>
        </div>
      );
    } else {
      return null
    }
  } else {
    return null
  }
  };
  export default Faciliteitensidebar
